/**
 * Connect.js, Stripe's forms for a tutor's own Stripe account, loaded once for the page.
 *
 * The page asks the server for a session whenever Stripe needs one, so a
 * tutor who leaves the form open past its few minutes is not stopped.
 */
let loading = null
let sessionError = null

/**
 * The server's own account of why the last session could not be had, or null.
 *
 * Connect.js reports a failed `fetchClientSecret` only as a load error of its
 * own, so the form reads the server's message from here.
 *
 * @returns {string|null}
 */
export function stripeSessionError() {
  return sessionError
}

export function loadStripeConnect(publishableKey) {
  loading ??= new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = 'https://connect-js.stripe.com/v1.0/connect.js'
    script.async = true
    script.onload = resolve
    script.onerror = error => {
      loading = null
      reject(error)
    }
    document.head.appendChild(script)
  }).then(() => window.StripeConnect.init({
    appearance: {
      overlays: 'dialog',
      variables: { colorPrimary: '#4f46e5' },
    },
    fetchClientSecret: async () => {
      try {
        const { data } = await window.axios.post('/teacher/settings/stripe-session')
        sessionError = null

        return data.client_secret
      } catch (failure) {
        sessionError = failure?.response?.data?.message ?? null
        throw failure
      }
    },
    locale: 'en-GB',
    publishableKey,
  }))

  return loading
}
